function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M450 841.86C590.28 841.86 704 819.922 704 792.86C704 765.798 590.28 743.86 450 743.86C309.72 743.86 196 765.798 196 792.86C196 819.922 309.72 841.86 450 841.86Z",
  fill: "#6CC566"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M44.5323 81.0195C67.6917 52.7609 189.88 42.2377 230.11 33.505L359.352 21.5013C511.318 3.6359 447.511 16.93 511.318 3.63589C586.704 -12.0689 648.135 25.5626 695.997 69.306C716.079 87.6216 735.299 107.548 743.906 131.125C764.594 187.772 720.292 253.232 752.484 306.178C777.623 347.481 841.676 366.187 864.399 408.42C879.795 437.048 872.504 470.619 858.359 499.627C847.565 521.794 832.415 543.241 809.54 558.055C780.179 577.061 741.728 583.093 704.802 588.395C600.017 603.449 492.675 617.313 387.728 602.989C355.072 598.539 323.097 591.385 291.126 584.232L290.461 584.083C260.343 577.341 230.016 570.529 201.999 559.256C171.899 547.092 145.189 530.107 118.678 513.242C71.763 483.382 45.3941 442.63 33.1702 381.111C7.1325 250.071 21.6487 325.094 7.1325 250.071C-10.3837 159.544 5.22003 128.894 44.5323 81.0195Z",
  fill: "#6CC566"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M559.08 202.98C558.487 202.313 557.874 201.647 557.24 200.98C562.07 195.5 567.08 189.87 567.03 182.82C566.98 174.26 559.38 167.68 556.54 159.59C552.68 148.59 558.04 136.77 560.24 125.31C561.948 116.013 561.584 106.454 559.174 97.3136C556.765 88.1734 552.369 79.6771 546.3 72.43C544.07 69.79 541.48 67.24 538.15 66.19C533.09 64.6 527.72 66.81 522.45 67.46C505.06 69.61 489.25 54.63 471.78 55.97C470.624 56.0115 469.485 56.2657 468.42 56.72C466.16 57.8 464.93 60.19 463.54 62.24C458.11 70.24 449 74.24 439.94 78.29C438.801 78.6258 437.717 79.1243 436.72 79.77C434 81.04 431.32 82.36 428.79 83.86C411.67 93.99 414.16 108.17 424.25 116.92C422.25 126.75 412.25 135.4 413.96 145.51C415.32 153.43 423.57 158.82 425.16 166.7C426.08 171.28 424.63 175.64 422.61 179.97C403.46 184.4 381.82 192.57 380.13 206.97C377.19 232.03 368.35 301.25 368.35 301.25C368.35 301.25 358.09 356.69 397 330.43L396.5 331.91C389.484 353.146 384.695 375.054 382.21 397.28C381.82 400.59 381.02 403.19 379.58 404.04C379.06 404.35 380.09 404.84 382.34 405.45C382.09 406.38 381.81 407.31 381.57 408.25C377.294 424.459 374.562 441.036 373.41 457.76C372.313 472.572 370.269 487.299 367.29 501.85C358.07 548.23 367.29 607.73 367.29 607.73L387.41 702.45L390.85 718.64C393.123 721.152 395.9 723.156 399 724.52C400.348 730.323 401.284 736.215 401.8 742.15C401.85 742.81 401.9 743.48 401.94 744.15C400.73 744.299 399.566 744.71 398.53 745.354C397.494 745.998 396.61 746.86 395.94 747.88C388.77 757.96 396.94 766.03 369.31 786.2C362.16 791.41 358.72 796.15 357.84 800.2C356.9 804.53 358.94 808.04 362.59 810.41C363.213 810.811 363.861 811.172 364.53 811.49C364.87 811.65 365.204 811.803 365.53 811.95C365.884 812.097 366.247 812.233 366.62 812.36H366.68L367.75 812.7H367.83L368.98 813H369.08L370.16 813.23H370.3L371.49 813.43H371.62L372.7 813.56H372.91L374.12 813.65H374.28H375.36H375.61H376.83H376.99L378.07 813.59H378.36L379.58 813.47H379.72L380.81 813.31L381.11 813.26L382.32 813.03H382.44L383.54 812.76L383.85 812.68C384.25 812.57 384.64 812.46 385.04 812.33H385.11L386.22 811.94L386.52 811.83C386.91 811.68 387.29 811.53 387.67 811.36C406.11 803.29 444.01 782.12 444.01 782.12V781.44C444.01 781.35 444.01 781.25 444.01 781.15C444.01 781.05 444.01 780.98 444.01 780.89C444.01 780.8 444.01 780.68 444.01 780.56V780.25C444.01 780.11 444.01 779.97 444.01 779.82V779.49C444.01 779.33 444.01 779.17 444.01 779C444.01 778.83 444.01 778.43 444.01 778.12C443.9 769.43 443 749.15 439 749.94C437.63 750.21 436.7 752.13 435.75 754.34L435.28 753.44C431.38 745.91 425.73 732.99 425.18 720.36C428.33 718.079 431.248 715.493 433.89 712.64C433.89 712.64 431.83 703.97 430.08 694.82C428.56 686.89 427.27 678.61 427.74 675.33C428.74 668.27 415.45 613.82 415.45 613.82C415.45 613.82 416.82 601.82 419.58 585.19C424.94 552.83 435.49 502.83 451.23 488.69C451.6 488.37 451.96 488.05 452.33 487.77C452.33 487.77 463.6 489.77 472.82 553.31L475.49 581.6C476.264 589.436 477.601 597.206 479.49 604.85C481.31 612.38 483.26 624.98 482.06 642.04C480.89 658.72 480.39 678.35 480.18 692.13C480.02 702.52 480.02 709.59 480.02 709.59C481.928 711.202 483.988 712.625 486.17 713.84V723.09C486.148 725.055 485.375 726.936 484.01 728.35C482.558 729.985 481.501 731.932 480.92 734.04C479.13 737.26 477.62 742.49 476.99 750.9C474.99 778.13 473.92 775.1 473.92 775.1C472.745 778.044 471.965 781.131 471.6 784.28C471.54 784.87 471.51 785.46 471.49 786.06C471.49 786.15 471.49 786.25 471.49 786.34C471.49 786.613 471.49 786.883 471.49 787.15C471.49 787.283 471.49 787.417 471.49 787.55C471.49 787.683 471.507 787.883 471.54 788.15C471.54 788.33 471.564 788.51 471.61 788.69C471.61 788.82 471.61 788.95 471.67 789.07C471.73 789.19 471.76 789.55 471.82 789.79L471.9 790.1C471.97 790.35 472.04 790.59 472.12 790.83L472.2 791.05C472.28 791.27 472.37 791.483 472.47 791.69L472.56 791.88C472.68 792.12 472.81 792.36 472.96 792.59L473.08 792.78C473.232 793.009 473.395 793.229 473.57 793.44L473.7 793.59C473.894 793.812 474.101 794.023 474.32 794.22L474.39 794.28C474.616 794.477 474.853 794.661 475.1 794.83L475.21 794.91C475.481 795.086 475.761 795.247 476.05 795.39L476.22 795.48C476.546 795.629 476.88 795.759 477.22 795.87L477.39 795.92C477.765 796.044 478.145 796.147 478.53 796.23C478.93 796.31 479.35 796.38 479.79 796.42H479.97C480.41 796.42 480.87 796.49 481.35 796.49H481.62C482.11 796.49 482.62 796.49 483.14 796.49H483.39C483.95 796.49 484.54 796.39 485.15 796.3C506.66 793.3 516.91 791.3 515.88 779.16C515.26 771.87 513.53 761.28 512.25 754.01C511.602 750.321 510.409 746.748 508.71 743.41C508.764 742.843 508.814 742.26 508.86 741.66C509.23 736.66 509.21 730.66 507.69 726.73L508.16 717.9C513.484 716.546 518.295 713.664 522 709.61C522 709.61 522.15 703.07 522.6 694.39C523.28 680.99 524.6 662.5 527.12 655.16C531.22 643.06 527.12 600.71 527.12 600.71C527.12 600.71 511.75 528.11 526.12 496.85C538.77 469.28 538.66 441.69 526.49 414.85C526.73 414.661 526.948 414.447 527.14 414.21C527.14 414.21 524.07 412.21 525.14 389C525.92 371.3 520.74 353 518.24 345.36C522.151 347.038 526.158 348.48 530.24 349.68C553.75 356.69 555.8 330.43 555.8 330.43L560.92 291.1L567 232.53C568.66 227.93 570.89 216.43 559.08 202.98ZM454.94 164.13C454.94 164.78 454.87 165.43 454.8 166.07C454.611 168.155 454.171 170.21 453.49 172.19C454.191 169.514 454.616 166.773 454.76 164.01L454.94 164.13ZM516.87 307.28C517.23 307.95 517.58 308.59 517.87 309.28L515.28 307.96C516.239 303.205 517.791 298.589 519.9 294.22C522.446 289.136 524.54 283.839 526.16 278.39C526.088 284.686 526.392 290.98 527.07 297.24C529.16 313.33 516.87 307.28 516.87 307.28Z",
  fill: "url(#paint0_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M430 88.05C426.73 90.28 423.3 92.8599 422.14 96.6499C420.26 102.76 424.98 108.89 425.44 115.27C426.29 126.86 413.18 136.44 415.11 147.91C416.43 155.77 424.49 161.11 426.04 168.91C428.3 180.31 415.95 190.36 416.92 201.91C417.44 208.08 421.73 213.32 426.59 217.14C433.423 222.489 441.6 225.845 450.22 226.84C449.65 216.93 442.29 207.9 443.56 198.05C444.43 191.3 449.18 185.77 451.93 179.54C456.76 168.6 455.21 155.94 452.32 144.34C449.43 132.74 445.24 121.27 445.03 109.34C444.9 102.14 448.28 91.5699 445.8 84.7399C442.79 76.4299 435.61 84.22 430 88.05Z",
  fill: "#F78181"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M430 88.05C426.73 90.28 423.3 92.8599 422.14 96.6499C420.26 102.76 424.98 108.89 425.44 115.27C426.29 126.86 413.18 136.44 415.11 147.91C416.43 155.77 424.49 161.11 426.04 168.91C428.3 180.31 415.95 190.36 416.92 201.91C417.44 208.08 421.73 213.32 426.59 217.14C433.423 222.489 441.6 225.845 450.22 226.84C449.65 216.93 442.29 207.9 443.56 198.05C444.43 191.3 449.18 185.77 451.93 179.54C456.76 168.6 455.21 155.94 452.32 144.34C449.43 132.74 445.24 121.27 445.03 109.34C444.9 102.14 448.28 91.5699 445.8 84.7399C442.79 76.4299 435.61 84.22 430 88.05Z",
  fill: "#EE6C4D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.59 757.36L430.59 766.36C430.59 766.36 398.59 783.36 402.59 760.36C403.684 753.523 403.916 746.575 403.28 739.68C402.453 730.056 400.545 720.556 397.59 711.36L427.59 705.36C422.59 721.04 430.82 740.78 435.95 750.83C438 754.88 439.59 757.36 439.59 757.36Z",
  fill: "#FFB9B9"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M507.73 739.17C507.506 742.251 507.125 745.318 506.59 748.36C506.59 748.36 481.59 765.36 479.59 746.36C478.29 733.98 481.23 728.36 483.45 726C484.781 724.59 485.531 722.729 485.55 720.79V698.36L507.55 705.36L506.55 724.36C508.07 728.31 508.09 734.21 507.73 739.17Z",
  fill: "#FFB9B9"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M439.59 757.36L430.59 766.36C430.59 766.36 398.59 783.36 402.59 760.36C403.684 753.523 403.916 746.575 403.28 739.68C410.28 738.68 418.59 746.36 418.59 746.36C430.31 762.9 433.47 756.64 435.95 750.83C438 754.88 439.59 757.36 439.59 757.36Z",
  fill: "black"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M418.591 748.36C418.591 748.36 404.591 735.36 397.591 745.36C390.591 755.36 398.591 763.36 371.591 783.36C344.591 803.36 371.591 816.36 389.591 808.36C407.591 800.36 444.591 779.36 444.591 779.36C444.591 779.36 444.591 746.36 439.591 747.36C434.591 748.36 435.591 772.36 418.591 748.36Z",
  fill: "#373F51"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M507.73 739.17C507.506 742.251 507.125 745.318 506.59 748.36C506.59 748.36 481.59 765.36 479.59 746.36C478.29 733.98 481.23 728.36 483.45 726C484.32 725.347 485.35 724.942 486.432 724.83C487.513 724.717 488.605 724.9 489.59 725.36C493.59 723.58 497.99 726.55 501.59 730.36C504.074 732.967 506.144 735.938 507.73 739.17Z",
  fill: "black"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M489.59 727.36C489.59 727.36 478.59 721.36 476.59 748.36C474.59 775.36 473.59 772.36 473.59 772.36C473.59 772.36 463.59 796.36 484.59 793.36C505.59 790.36 515.59 788.36 514.59 776.36C513.99 769.13 512.29 758.62 511.04 751.42C509.843 744.298 506.57 737.689 501.63 732.42C498 728.54 493.59 725.58 489.59 727.36Z",
  fill: "#373F51"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M525.59 599.36C525.59 599.36 529.59 641.36 525.59 653.36C523.16 660.64 521.84 678.98 521.18 692.27C520.74 700.87 520.59 707.36 520.59 707.36C501.59 727.36 479.59 707.36 479.59 707.36C479.59 707.36 479.59 700.36 479.75 690.04C479.96 676.37 480.45 656.9 481.59 640.36C482.76 623.44 480.86 610.95 479.08 603.48C477.244 595.898 475.948 588.195 475.2 580.43L472.59 552.37C463.59 489.37 452.59 487.37 452.59 487.37C452.23 487.65 451.88 487.96 451.52 488.28C436.15 502.28 425.85 551.89 420.62 583.98C417.93 600.49 416.62 612.37 416.62 612.37C416.62 612.37 429.62 666.37 428.62 673.37C428.16 676.62 429.42 684.84 430.9 692.7C432.61 701.77 434.62 710.37 434.62 710.37C409.62 737.37 392.62 716.37 392.62 716.37L389.26 700.31L369.62 606.37C369.62 606.37 360.62 547.37 369.62 501.37C372.537 486.934 374.541 472.328 375.62 457.64C376.755 441.06 379.433 424.622 383.62 408.54C384.84 403.78 386.193 399.057 387.68 394.37C387.68 394.37 425.23 387.84 460.59 387.84C487.11 387.84 512.39 391.51 519.68 404.37C521.36 407.33 522.887 410.297 524.26 413.27C536.92 440.48 537.26 468.43 524.68 496.37C510.59 527.36 525.59 599.36 525.59 599.36Z",
  fill: "#6D7380"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M441.59 236.36C441.59 236.36 388.59 182.36 428.59 186.36C437.66 187.27 443.8 185.65 447.87 182.61C452.51 179.15 454.46 173.85 455 168.32C456.1 157.32 451.59 145.32 451.59 145.32C451.59 145.32 505.59 102.32 494.59 156.32C493.383 161.808 492.68 167.394 492.49 173.01C492.31 184.47 496.08 188.86 501.37 190.66C510.29 193.71 523.55 189.44 529.59 199.32C540.59 217.36 441.59 236.36 441.59 236.36Z",
  fill: "#FFB9B9"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M494.59 156.36C493.382 161.848 492.679 167.434 492.49 173.05C491.051 173.548 489.585 173.966 488.1 174.3C482.462 175.571 476.626 175.695 470.94 174.664C465.253 173.634 459.833 171.469 455 168.3C456.1 157.3 451.59 145.3 451.59 145.3C451.59 145.3 505.59 102.36 494.59 156.36Z",
  fill: "black"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M521.59 130.36C521.59 141.764 517.059 152.701 508.995 160.766C500.931 168.83 489.994 173.36 478.59 173.36C467.186 173.36 456.248 168.83 448.184 160.766C440.12 152.701 435.59 141.764 435.59 130.36C435.59 129.56 435.59 128.76 435.66 127.97C436.298 116.802 441.263 106.321 449.501 98.7539C457.74 91.1864 468.603 87.1274 479.785 87.4384C490.968 87.7494 501.589 92.406 509.394 100.42C517.199 108.433 521.574 119.173 521.59 130.36Z",
  fill: "#FFB9B9"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M441.59 236.36C441.59 236.36 388.59 182.36 428.59 186.36C437.66 187.27 443.8 185.65 447.87 182.61C440.13 195.45 431.42 218.54 470.59 216.36C506.44 214.36 505.83 200.08 501.37 190.7C510.29 193.75 523.55 189.48 529.59 199.36C540.59 217.36 441.59 236.36 441.59 236.36Z",
  fill: "black"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M525.59 417.36C516.49 429.19 400.49 413.68 383.53 408.53C384.75 403.77 386.104 399.047 387.59 394.36C387.59 394.36 425.14 387.83 460.5 387.83C487.02 387.83 512.3 391.5 519.59 404.36C521.27 407.32 522.797 410.287 524.17 413.26C524.81 416.84 525.59 417.36 525.59 417.36Z",
  fill: "black"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M452.59 177.36C452.59 177.36 385.09 182.86 382.09 208.86C379.22 233.72 370.59 302.36 370.59 302.36C370.59 302.36 360.59 357.36 398.59 331.36L398.1 332.82C391.247 353.897 386.573 375.62 384.15 397.65C383.76 400.93 382.99 403.51 381.58 404.36C376.58 407.36 515.58 427.36 525.58 414.36C525.58 414.36 522.58 412.36 523.58 389.36C524.58 366.36 515.58 342.36 515.58 342.36C515.58 342.36 507.58 318.36 518.58 295.36C529.58 272.36 525.58 265.36 525.58 265.36L563.58 236.36C563.58 236.36 571.79 222.29 556.78 204.93C552.275 199.793 546.801 195.595 540.672 192.575C534.543 189.555 527.879 187.773 521.06 187.33L494.86 185.43C494.86 185.43 523.58 216.33 469.58 219.33C415.58 222.33 452.59 177.36 452.59 177.36Z",
  fill: "#008DD5"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M407.59 232.36C407.59 232.36 409.59 248.36 405.59 253.36C401.59 258.36 400.59 281.36 405.59 295.36",
  fill: "black"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M451.52 488.27C436.15 502.27 425.85 551.88 420.62 583.97C413.34 539.3 443.62 465.36 443.62 465.36L451.52 488.27Z",
  fill: "black"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M434.591 710.36C409.591 737.36 392.591 716.36 392.591 716.36L389.23 700.3C398.68 705.21 414.65 709.02 430.87 692.69C432.58 701.76 434.591 710.36 434.591 710.36Z",
  fill: "black"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M521.18 692.27C520.74 700.87 520.59 707.36 520.59 707.36C501.59 727.36 479.59 707.36 479.59 707.36C479.59 707.36 479.59 700.36 479.75 690.04C488 695.28 502.83 701.05 521.18 692.27Z",
  fill: "black"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M435.964 247.679L438.932 308.106C439.034 310.175 440.793 311.769 442.862 311.668L463.337 310.662C465.406 310.56 467 308.801 466.898 306.732L463.93 246.305C463.828 244.237 462.069 242.642 460.001 242.744L439.525 243.75C437.457 243.851 435.862 245.611 435.964 247.679Z",
  fill: "#CDD0DB"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M435.964 247.679L438.932 308.106C439.034 310.175 440.793 311.769 442.862 311.668L463.337 310.662C465.406 310.56 467 308.801 466.898 306.732L463.93 246.305C463.828 244.237 462.069 242.642 460.001 242.744L439.525 243.75C437.457 243.851 435.862 245.611 435.964 247.679Z",
  fill: "black"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M436.963 247.63L439.931 308.057C440.033 310.126 441.792 311.72 443.861 311.619L464.336 310.613C466.405 310.511 467.999 308.752 467.898 306.683L464.929 246.256C464.827 244.188 463.068 242.593 461 242.695L440.524 243.701C438.456 243.802 436.861 245.562 436.963 247.63Z",
  fill: "#373F51"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M453.971 257.558C453.889 255.903 452.482 254.627 450.827 254.708C449.172 254.79 447.897 256.197 447.978 257.852C448.059 259.507 449.467 260.782 451.121 260.701C452.776 260.62 454.052 259.212 453.971 257.558Z",
  fill: "#9DA7C0"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M383.65 310.7C384.552 308.013 386.031 305.556 387.983 303.5C389.935 301.444 392.313 299.84 394.95 298.8C398.37 297.38 402.54 294.8 404.65 290.09C408.59 281.36 415.59 272.36 433.59 278.36C451.59 284.36 428.59 288.36 428.59 288.36C428.59 288.36 469.59 282.36 453.59 294.36C437.59 306.36 417.59 313.36 417.59 313.36L407.74 323.79C401.74 330.16 391.32 330.13 385.74 323.35C383.24 320.29 381.92 316.17 383.65 310.7Z",
  fill: "black"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M382.65 308.7C383.552 306.013 385.031 303.556 386.983 301.5C388.935 299.444 391.313 297.84 393.95 296.8C397.37 295.38 401.54 292.8 403.65 288.09C407.59 279.36 419.5 271 437.5 277C437.5 283.5 437.5 285 437.5 285C437.5 285 468.59 280.36 452.59 292.36C436.59 304.36 416.59 311.36 416.59 311.36L406.74 321.79C400.74 328.16 390.32 328.13 384.74 321.35C382.24 318.29 380.92 314.17 382.65 308.7Z",
  fill: "#FFB9B9"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M523.59 329.36L516.59 346.36L507.59 339.77L482.59 321.36L465.59 310.36C441.59 292.36 465.59 289.36 465.59 289.36C456.59 285.36 465.59 281.36 465.59 281.36C497.59 274.36 491.59 300.36 491.59 300.36L511.86 310.87L518.59 314.36L523.59 329.36Z",
  fill: "black"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M525.59 327.36L518.59 344.36L509.59 337.77L484.59 319.36L467.59 308.36C443.59 290.36 466.501 287 466.501 287C466.501 281 466.5 278 466.5 278C498.5 271 493.59 298.36 493.59 298.36L513.86 308.87L520.59 312.36L525.59 327.36Z",
  fill: "#FFB9B9"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M525.59 327.36L518.59 344.36L509.59 337.77C517.7 338.06 527.28 334.14 513.82 308.87L520.55 312.36L525.59 327.36Z",
  fill: "black"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M562.59 226.36L564.52 234.23L558.59 292.36L553.59 331.36C553.59 331.36 551.59 357.36 528.59 350.36C505.59 343.36 503.59 336.36 503.59 336.36C503.59 336.36 536.59 347.36 515.59 308.36C515.59 308.36 527.59 314.36 525.59 298.36C523.59 282.36 525.59 254.36 525.59 254.36L562.59 226.36Z",
  fill: "#008DD5"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.05,
  d: "M521.59 130.36C521.591 140.112 518.277 149.576 512.192 157.196C506.107 164.817 497.611 170.143 488.1 172.3C486.66 168.14 485.64 164 486.69 159.79C488.69 151.62 498.15 145.66 497.1 137.31C496.997 136.365 496.653 135.463 496.1 134.69C493.99 131.91 489.69 133.29 486.27 133.98C477.43 135.74 467.75 129.77 465.35 121.08C461.51 124.857 456.699 127.5 451.451 128.716C446.203 129.932 440.721 129.674 435.61 127.97C436.248 116.802 441.213 106.321 449.452 98.7539C457.69 91.1864 468.554 87.1274 479.736 87.4384C490.918 87.7494 501.539 92.406 509.344 100.42C517.149 108.433 521.524 119.173 521.54 130.36H521.59Z",
  fill: "black"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M466.4 119.08C468.79 127.77 478.48 133.74 487.31 131.97C490.73 131.29 495.03 129.91 497.14 132.69C497.679 133.462 498.007 134.362 498.09 135.3C499.15 143.66 489.72 149.61 487.69 157.79C485.6 166.21 491.69 174.34 493.04 182.91C493.75 187.6 493.04 192.38 493.04 197.12C493.04 201.86 494.16 206.96 497.68 210.12C501.2 213.28 507.68 213.34 510.05 209.22C521.3 215.17 516.81 233.6 525.35 243.03C530.06 248.23 537.81 249.48 544.8 248.82C546.437 248.794 548.029 248.279 549.37 247.34C550.526 246.2 551.307 244.735 551.61 243.14C553.375 236.464 553.071 229.41 550.74 222.91C549.62 219.8 548.01 216.66 548.43 213.39C548.75 210.83 550.28 208.6 551.9 206.59C557.27 199.93 564.6 193.49 564.55 184.93C564.5 176.37 557.08 169.93 554.31 161.93C550.54 151 555.77 139.29 557.92 127.93C559.602 118.717 559.256 109.247 556.907 100.181C554.559 91.1145 550.264 82.6685 544.32 75.43C542.14 72.81 539.61 70.28 536.32 69.24C531.39 67.66 526.14 69.86 520.99 70.5C503.99 72.63 488.58 57.77 471.52 59.1C470.39 59.1435 469.278 59.3979 468.24 59.85C466.03 60.92 464.84 63.29 463.47 65.33C455.94 76.58 441.14 79.79 429.54 86.77C395.71 107.14 440.49 144.02 466.4 119.08Z",
  fill: "#EE6C4D"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M389.59 804.36C377.9 809.55 362.43 805.89 360.4 797.22C357.95 808.68 376.24 814.3 389.59 808.36C407.59 800.36 444.59 779.36 444.59 779.36C444.59 779.36 444.59 777.81 444.54 775.36C443.46 776 407.32 796.43 389.59 804.36Z",
  fill: "white"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.3,
  d: "M514.54 775.78C513.39 784.78 503.41 786.67 484.59 789.36C475.02 790.73 471.9 786.48 471.32 781.46C470.69 787.89 472.52 795.08 484.59 793.36C505.59 790.36 515.59 788.36 514.59 776.36C514.57 776.17 514.55 775.97 514.54 775.78Z",
  fill: "white"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M638.26 793.82C638.26 793.82 623.78 720.43 653.59 670.18C666.23 649.172 671.715 624.63 669.22 600.24C667.935 588.67 665.591 577.242 662.22 566.1",
  stroke: "#F7BCAE",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M680.85 534.3C680.05 543.05 661.85 566.98 661.85 566.98C661.85 566.98 648.33 540.14 649.14 531.38C649.291 529.267 649.861 527.206 650.818 525.316C651.775 523.426 653.1 521.747 654.714 520.376C656.329 519.004 658.2 517.969 660.22 517.33C662.24 516.692 664.366 516.463 666.476 516.656C668.585 516.85 670.634 517.462 672.504 518.458C674.373 519.454 676.026 520.812 677.363 522.455C678.701 524.097 679.698 525.99 680.295 528.022C680.892 530.054 681.077 532.185 680.84 534.29L680.85 534.3Z",
  fill: "#6CC566"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M702.6 585.2C697.17 592.11 668.9 602.32 668.9 602.32C668.9 602.32 672.14 572.44 677.57 565.53C678.825 563.786 680.419 562.314 682.258 561.203C684.096 560.091 686.141 559.363 688.268 559.063C690.395 558.763 692.561 558.896 694.636 559.455C696.71 560.014 698.65 560.987 700.338 562.315C702.026 563.644 703.428 565.3 704.46 567.185C705.491 569.069 706.13 571.143 706.339 573.281C706.547 575.419 706.321 577.578 705.673 579.626C705.026 581.674 703.97 583.57 702.57 585.2H702.6Z",
  fill: "#6CC566"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.84 667.96C685.66 671.18 656.11 665.72 656.11 665.72C656.11 665.72 673.99 641.56 682.17 638.34C684.123 637.535 686.216 637.126 688.327 637.138C690.439 637.15 692.527 637.582 694.471 638.408C696.414 639.235 698.173 640.44 699.646 641.953C701.119 643.466 702.277 645.257 703.051 647.222C703.825 649.187 704.2 651.286 704.155 653.397C704.11 655.509 703.646 657.59 702.789 659.52C701.931 661.45 700.699 663.19 699.163 664.639C697.626 666.088 695.817 667.217 693.84 667.96Z",
  fill: "#6CC566"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M673.11 729.08C665.59 733.64 635.54 733.25 635.54 733.25C635.54 733.25 649.09 706.43 656.6 701.86C658.388 700.735 660.382 699.976 662.467 699.63C664.551 699.283 666.683 699.354 668.739 699.84C670.795 700.325 672.734 701.215 674.443 702.458C676.152 703.701 677.596 705.271 678.692 707.077C679.788 708.884 680.513 710.89 680.825 712.98C681.138 715.069 681.031 717.2 680.511 719.248C679.992 721.296 679.07 723.22 677.799 724.908C676.528 726.596 674.934 728.014 673.11 729.08Z",
  fill: "#6CC566"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M635.46 600.95C641.18 607.63 669.85 616.63 669.85 616.63C669.85 616.63 665.35 586.91 659.64 580.24C656.873 577.103 652.984 575.18 648.811 574.888C644.639 574.595 640.519 575.957 637.342 578.677C634.166 581.398 632.187 585.26 631.835 589.428C631.483 593.596 632.785 597.735 635.46 600.95Z",
  fill: "#6CC566"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M612.12 672.75C619.57 677.41 649.63 677.42 649.63 677.42C649.63 677.42 636.45 650.43 629 645.75C627.227 644.608 625.245 643.83 623.168 643.461C621.092 643.092 618.963 643.139 616.905 643.599C614.847 644.059 612.901 644.924 611.18 646.143C609.459 647.362 607.997 648.911 606.88 650.699C605.762 652.488 605.011 654.48 604.67 656.562C604.329 658.643 604.405 660.771 604.894 662.822C605.382 664.874 606.274 666.808 607.516 668.512C608.758 670.217 610.327 671.657 612.13 672.75H612.12Z",
  fill: "#6CC566"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M599 745.64C605.56 751.49 635.18 756.59 635.18 756.59C635.18 756.59 626.75 727.74 620.18 721.89C618.635 720.416 616.809 719.269 614.811 718.515C612.813 717.762 610.684 717.418 608.55 717.504C606.416 717.59 604.322 718.105 602.391 719.018C600.46 719.93 598.733 721.221 597.312 722.815C595.891 724.409 594.804 726.272 594.118 728.294C593.432 730.316 593.159 732.456 593.317 734.586C593.474 736.715 594.059 738.791 595.035 740.69C596.011 742.589 597.36 744.273 599 745.64Z",
  fill: "#6CC566"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M257.289 193.909L257.491 193.808L257.652 195.956C258.11 198.872 258.331 201.82 258.314 204.772L263.039 267.772C263.19 269.783 262.75 271.794 261.774 273.558C260.799 275.323 259.329 276.764 257.546 277.705L228.213 293.185C226.316 294.186 224.155 294.573 222.029 294.293C219.903 294.014 217.916 293.081 216.343 291.623L167.927 246.777C166.482 245.571 165.099 244.29 163.786 242.941L162.142 241.419L162.291 241.344C156.623 235.036 152.488 227.505 150.209 219.337C147.93 211.168 147.568 202.584 149.151 194.253C150.735 185.922 154.221 178.069 159.338 171.306C164.455 164.544 171.064 159.054 178.651 155.266C186.238 151.477 194.598 149.492 203.078 149.465C211.558 149.438 219.93 151.37 227.541 155.11C235.152 158.85 241.796 164.298 246.956 171.028C252.116 177.757 255.652 185.588 257.289 193.909L257.289 193.909Z",
  fill: "#F9D048"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M227.614 297.614C228.159 297.426 228.69 297.196 229.2 296.927L259.861 280.746C261.809 279.718 263.414 278.145 264.48 276.218C265.545 274.291 266.025 272.095 265.86 269.899L260.921 204.047C260.938 200.949 260.705 197.854 260.225 194.792L259.716 192.013C257.886 183.202 254.034 174.937 248.463 167.87C242.892 160.804 235.754 155.129 227.614 151.294C219.474 147.458 210.553 145.568 201.557 145.771C192.561 145.975 183.735 148.266 175.776 152.465L176.228 153.321C184.102 149.172 192.836 146.92 201.734 146.746C210.632 146.571 219.448 148.478 227.478 152.316C235.508 156.153 242.531 161.813 247.985 168.846C253.439 175.879 257.174 184.089 258.892 192.821L259.265 194.904C259.741 197.939 259.971 201.008 259.955 204.081L264.895 269.971C265.046 271.979 264.607 273.987 263.633 275.749C262.659 277.512 261.191 278.951 259.41 279.89L228.749 296.071C226.854 297.068 224.697 297.454 222.575 297.175C220.452 296.895 218.468 295.965 216.896 294.512L216.238 295.221C217.741 296.611 219.593 297.567 221.596 297.988C223.599 298.409 225.678 298.28 227.614 297.614Z",
  fill: "#008DD5"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M239.792 324.041L279.08 303.308C279.372 303.152 279.59 302.887 279.686 302.571C279.783 302.254 279.751 301.913 279.596 301.62C279.442 301.328 279.178 301.108 278.863 301.01C278.547 300.911 278.205 300.942 277.912 301.094L238.624 321.828C238.477 321.904 238.347 322.008 238.242 322.135C238.136 322.261 238.056 322.407 238.007 322.565C237.958 322.722 237.94 322.888 237.955 323.052C237.97 323.216 238.017 323.376 238.094 323.522C238.171 323.668 238.277 323.797 238.404 323.902C238.531 324.007 238.677 324.086 238.835 324.135C238.993 324.183 239.159 324.199 239.323 324.183C239.487 324.167 239.646 324.119 239.792 324.041Z",
  fill: "#6D7380"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M235.688 315.595L274.976 294.861C275.123 294.785 275.253 294.681 275.358 294.554C275.464 294.428 275.544 294.282 275.593 294.124C275.642 293.967 275.66 293.801 275.645 293.637C275.63 293.473 275.583 293.313 275.506 293.167C275.429 293.021 275.323 292.892 275.196 292.787C275.069 292.682 274.923 292.603 274.765 292.555C274.607 292.506 274.441 292.49 274.277 292.506C274.113 292.522 273.954 292.57 273.808 292.648L234.52 313.381C234.374 313.458 234.244 313.562 234.138 313.688C234.032 313.815 233.952 313.961 233.903 314.119C233.854 314.276 233.836 314.442 233.851 314.606C233.866 314.77 233.914 314.93 233.991 315.076C234.068 315.222 234.173 315.351 234.3 315.456C234.427 315.561 234.574 315.64 234.731 315.688C234.889 315.736 235.055 315.753 235.219 315.737C235.383 315.721 235.543 315.673 235.688 315.595Z",
  fill: "#6D7380"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M231.584 307.149L270.872 286.415C271.164 286.259 271.382 285.994 271.478 285.678C271.575 285.362 271.543 285.02 271.388 284.728C271.234 284.435 270.97 284.216 270.655 284.117C270.339 284.019 269.997 284.049 269.704 284.202L230.416 304.935C230.124 305.091 229.906 305.356 229.809 305.672C229.713 305.989 229.745 306.33 229.899 306.623C230.054 306.915 230.317 307.134 230.633 307.233C230.949 307.332 231.29 307.301 231.584 307.149L231.584 307.149Z",
  fill: "#6D7380"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M263.601 321.569C255.808 325.681 247.199 324.672 244.371 319.314L272.592 304.421C275.42 309.779 271.394 317.456 263.601 321.569Z",
  fill: "#6D7380"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.117 230.041L233.382 277.054L232.411 277.844L194.147 230.83L195.117 230.041Z",
  fill: "#008DD5"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M225.577 213.965L226.776 213.609L244.005 271.726L242.805 272.082L225.577 213.965Z",
  fill: "#008DD5"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M209.283 212.47C210.96 211.585 211.942 209.68 212.422 208.465C212.579 208.067 212.725 207.659 212.872 207.251C213.406 205.764 213.91 204.36 214.942 203.362C217.22 201.159 221.029 201.825 224.454 202.768L224.786 201.562C221.021 200.524 216.805 199.82 214.072 202.462C212.831 203.662 212.253 205.272 211.694 206.828C211.552 207.224 211.41 207.619 211.258 208.005C210.759 209.269 209.639 211.424 207.728 211.675C206.9 211.715 206.073 211.586 205.297 211.295C204.718 211.111 204.126 210.971 203.526 210.879C202.325 210.74 201.11 210.96 200.033 211.51C198.957 212.06 198.067 212.916 197.476 213.971C197.271 214.364 197.088 214.768 196.928 215.181C196.605 215.971 196.3 216.717 195.718 217.151C194.857 217.794 193.645 217.593 192.361 217.383C191.036 217.165 189.667 216.94 188.411 217.545C188.37 217.565 188.329 217.586 188.289 217.607C186.083 218.771 185.897 221.718 185.953 223.851L187.204 223.818C187.128 220.919 187.686 219.272 188.954 218.673C189.854 218.239 190.973 218.423 192.158 218.618C193.643 218.862 195.18 219.114 196.466 218.154C197.327 217.513 197.713 216.568 198.086 215.655C198.23 215.284 198.393 214.922 198.576 214.569C199.05 213.739 199.756 213.066 200.606 212.631C201.457 212.196 202.416 212.019 203.366 212.12C203.902 212.205 204.431 212.331 204.947 212.497C205.888 212.842 206.891 212.985 207.89 212.916C208.378 212.851 208.849 212.7 209.283 212.47Z",
  fill: "#008DD5"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 241L332.825 241.605",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 194.685L332.316 188",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M277.501 152L316.618 132.23",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M252 121.528L272.894 83",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref59 =
/*#__PURE__*/
React.createElement("line", {
  x1: 148.247,
  y1: 86.9035,
  x2: 167.471,
  y2: 126.292,
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208 72L208.262 115.828",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M177.948 296.5L150.32 330.525",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.399 266.812L109.503 295.774",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M117.007 230.625L76.7587 247.976",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.965 191.519L67 182.86",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100.155 126L133.627 154.295",
  stroke: "#F9D048",
  strokeWidth: 5
});

var _ref66 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 463,
  y1: 813.86,
  x2: 463,
  y2: 55.86,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#808080",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "#808080",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#808080",
  stopOpacity: 0.1
})));

var SvgMobileIdeas = function SvgMobileIdeas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 873,
    height: 842,
    viewBox: "0 0 873 842",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMobileIdeas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileIdeas.801f5b06.svg";
export { ForwardRef as ReactComponent };